<template>
  <article class="banner-block">
    <div class="row">
      <div class="banner-main" :class="bannerCol">
        <h2 class="title" :class="titleClass">
          <slot name="title"></slot>
        </h2>
        <p class="message typo-body2" :class="messageClass">
          <slot name="message"></slot>
        </p>

        <div class="btn-group">
          <slot name="actions"></slot>
        </div>
      </div>
      <slot name="default"></slot>
    </div>
  </article>
</template>

<script>
export default {
  name: "BannerBlock",
  props: {
    title: String,
    titleClass: String,
    messageClass: String,
    bannerCol: {
      type: String,
      default: "col-12 col-sm-7"
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-block {
  display: flex;
  padding: 28px 32px 32px 32px;
  background: #fff;
  border-radius: 10px;
  // min-width: calc(648px - 32px * 2);
  // width: calc(67.5% - 32px - 32px - 12px);
  // max-width: 60%;
  min-height: calc(297px - 28px - 32px);

  .banner-main {
    display: flex;
    flex-direction: column;
    flex: 1;
    // max-width: 40%;

    .title {
      font-weight: 600;
      font-size: 32px;
      line-height: 120%;
    }
    .message {
      margin-top: 12px;
      margin-bottom: 12px;
    }

    .btn-group {
      margin-top: auto;
    }
  }
}
.banner-img::v-deep {
  max-width: 288px;
  width: 100%;
  margin-left: auto;
}
@media (max-width: 767px) {
  .banner-block {
    min-height: unset;
    .banner-main {
      .title {
        font-size: 28px;
      }
      .message {
      }
    }
  }
}

@media (max-width: 575px) {
  .banner-block {
    .banner-main {
      .title {
        font-size: 24px;
      }
      .message {
      }
    }
  }
}
</style>
